import React, { useEffect, useState } from 'react';
import { Route, Switch } from 'react-router-dom';

import Welcome from './components/Welcome/Welcome';
import Test from './components/Test/Test';
import Dashboard from './components/Dashboard/Dashboard';
import {question_one} from './api'

const App = () => {
    const [name, setName] = useState('');
    const [currentId, setCurrentId] = useState(1)
    const [questions, setQuestions] = useState([])
    const [clickOption, setClickOption] =useState('')
    const [correct, setCorrect] = useState('-')

    const [mark, setMark] = useState(0)
    useEffect(()=>{
        setQuestions(question_one.reverse())
    },[])
    const handleNameChange = ( nameVal) => {
        setName(nameVal)        
    }
    const handleOptionClicked = (option, cor) =>{
        setClickOption(option)
        setCorrect(cor)
    }
    const handleSwipe = () =>{
        const newList = questions.filter((item) => item.id !== currentId);
        setCurrentId(currentId+1)
        setQuestions(newList)
        if(correct === clickOption){
            setMark(mark+1)
        }
        setClickOption('')
        setCorrect('-')
    }
    if(currentId === 60){
        localStorage.setItem('write', 'no')
        localStorage.setItem('mark', `${mark}`)
        localStorage.setItem('name', name)

    }
    return (

        <div  className="container" style={{backgroundImage: "url(/background.jpg)" }} >

             <Switch>
            <Route exact path="/" >
                {localStorage.getItem('write') === 'no'?  <div className="answer" > <h1>Hey! {localStorage.getItem('name')} <br/>You Got : { parseInt(localStorage.getItem('mark'))} out of 59</h1><h4>Take a picture/screenshot and Send to Derrick</h4></div>: <Welcome name={name} handleNameChange={handleNameChange}/>}
            </Route>
            <Route path="/test">
                {localStorage.getItem('write') === 'no'? <div className="answer" > <h1>Hey! {localStorage.getItem('name')} <br/>You Got : { parseInt(localStorage.getItem('mark'))} out of 59</h1><h4>Take a picture/screenshot and Send to Derrick</h4></div>:<Test questions={questions} handleSwipe={handleSwipe} name={name} mark={mark} handleOptionClicked={handleOptionClicked} clickOption={clickOption}/>}
                
            </Route>
            <Route path="/dashboard">
                <Dashboard />
            </Route>
        </Switch>
        </div>
       
    )
}

export default App;
